var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.topLevelGroups.length > 0
    ? _c(
        "div",
        _vm._l(_vm.topLevelGroups, function (group) {
          return _c("app-group-select-node", {
            key: group.ID,
            attrs: {
              value: group,
              "use-ids": _vm.useIds,
              "selected-value": _vm.value,
            },
            on: {
              click: function ($event) {
                return _vm.onClick($event)
              },
            },
          })
        }),
        1
      )
    : _c("div", [_vm._v(" " + _vm._s(_vm.$ct("you-have-no-groups")) + " ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }